module.exports = __webpack_public_path__ + "img/logo-indosat-ooredoo.dbe80be0.png";